import * as Sentry from '@sentry/nextjs';

import { DeviceCheckResult } from '~/generated/graphql';
import pingServer from '~/helpers/deviceChecks/pingServer';
import { DeviceCheckMetadata } from '~/types';

const checkUrls: DeviceCheckMetadata['check'] = async ({
  urls,
  registrationDetails,
}) => {
  try {
    if (!urls) {
      throw new Error('Expected value not provided');
    }

    const promises = urls.map(url => pingServer(url, registrationDetails));
    const results = await Promise.all(promises);

    if (results.every(result => result)) {
      return {
        result: DeviceCheckResult.Pass,
      };
    }

    throw new Error('Some URLs failed to respond successfully');
  } catch (err) {
    const e = err as Error;
    const error = new Error(
      JSON.stringify({
        error: e.message,
        registrationDetails,
      }),
    );

    Sentry.captureException(error);
    return {
      result: DeviceCheckResult.Fail,
      value: e.message,
    };
  }
};

export default checkUrls;
